const ITEMS = [
  "ENTERPRISE TRANSFORMATIONS",
  "SAP S/4HANA FI & CO ARCHITECTURE",
  "RISE WITH SAP",
  "CENTRAL FINANCE INTEGRATION",
  "FSCM & TREASURY",
  "REVENUE ACCOUNTING (RAR)",
  "CERTIFICATION PREPARATION",
  "GREENFIELD & SYSTEM CONVERSION",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-slate-200 bg-[#F8FAFC] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-sm sm:text-base font-bold tracking-wide text-slate-700">{item}</span>
            <span className="text-amber-600 text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
